<template>
  <RequestsList :shop-id="2" shop-name="فروشگاه" />
</template>

<script>

import RequestsList from "@/components/requests/RequestsList.vue";

export default {
  name: "ShopRequest",
  components: {RequestsList},
}
</script>

<style scoped>

</style>